module.exports = __webpack_public_path__ + "img/stagefright.a2b4b41a.jpg";